/**
 * FullStacked Cloud Console - Minimal top navigation bar (console.md, "Top Navigation Bar"):
 * the "FullStacked Cloud" title (with a subtle badge outside live) on the left; the plan chip,
 * Invitations, the username and Sign Out on the right. Section tabs live in the tab bar below.
 */

import { useApp } from "../app-context.ts";
import { usernameOf } from "../lib/access.ts";
import { Icon } from "../ui/icons.tsx";
import { InvitationsLink, PlanChip } from "./plan-chip.tsx";

export function ConsoleHeader() {
    const { config, session, access, signOut } = useApp();
    const username = usernameOf(access, session.user?.slug);
    return (
        <header className="console-header">
            <div className="brand-row">
                <span className="brand-text">FullStacked Cloud</span>
                {config.isProduction ? null : (
                    <span
                        className="badge badge-env-test"
                        title="Non-production sandbox environment"
                    >
                        {config.environment}
                    </span>
                )}
            </div>
            <div className="header-actions">
                <PlanChip />
                <InvitationsLink />
                {username ? (
                    <span className="header-username mono" title={access?.user.email}>
                        {username}
                    </span>
                ) : null}
                <button className="btn btn-ghost btn-sm" onClick={signOut}>
                    <Icon name="logout" />
                    Sign Out
                </button>
            </div>
        </header>
    );
}
